// import { useState, useEffect } from "react";

// export default function useSessionStorage<T>(key: string, initialValue: T) {
//   // 1. Gunakan Lazy Initialization (fungsi di dalam useState)
//   const [value, setValue] = useState<T>(() => {
//     // Cek apakah kode jalan di browser (bukan server)
//     if (typeof window === "undefined") {
//       return initialValue;
//     }

//     try {
//       // Coba akses storage
//       const storedValue = window.sessionStorage.getItem(key);
//       // Return value dari storage jika ada, atau initialValue jika null
//       return storedValue ? JSON.parse(storedValue) : initialValue;
//     } catch (error) {
//       // Jika akses ditolak atau error parsing, fallback ke initialValue
//       console.warn(`Error reading sessionStorage key "${key}":`, error);
//       return initialValue;
//     }
//   });

//   // 2. Update storage ketika value berubah
//   useEffect(() => {
//     // Cek environment browser lagi
//     if (typeof window === "undefined") return;

//     try {
//       window.sessionStorage.setItem(key, JSON.stringify(value));
//     } catch (error) {
//       console.warn(`Error setting sessionStorage key "${key}":`, error);
//       // Opsional: Handle QuotaExceededError (jika storage penuh)
//     }
//   }, [key, value]);

//   return [value, setValue] as const;
// }

// import { useState, useEffect } from "react";

// // 1. Buat penyimpanan memori global di luar hook
// // Ini berfungsi sebagai "sessionStorage palsu" jika browser memblokir akses
// const memoryFallback = new Map<string, string>();

// // 2. Fungsi utilitas untuk mengecek apakah sessionStorage benar-benar bisa ditulis
// const isStorageAvailable = () => {
//   if (typeof window === "undefined") return false;
//   try {
//     const testKey = "__storage_test__";
//     window.sessionStorage.setItem(testKey, testKey);
//     window.sessionStorage.removeItem(testKey);
//     return true;
//   } catch (e) {
//     return false; // Safari Private Mode akan masuk ke sini
//   }
// };

// // Cek ketersediaan cukup sekali saat file ini di-load
// const hasStorage = isStorageAvailable();

// export default function useSessionStorage<T>(key: string, initialValue: T) {
//   // 3. Lazy Initialization
//   const [value, setValue] = useState<T>(() => {
//     if (typeof window === "undefined") {
//       return initialValue;
//     }

//     try {
//       let storedValue: string | null = null;

//       if (hasStorage) {
//         // Ambil dari storage asli
//         storedValue = window.sessionStorage.getItem(key);
//       } else {
//         // Ambil dari memori fallback jika Safari memblokir
//         storedValue = memoryFallback.get(key) || null;
//       }

//       return storedValue ? JSON.parse(storedValue) : initialValue;
//     } catch (error) {
//       console.warn(`Error reading session storage key "${key}":`, error);
//       return initialValue;
//     }
//   });

//   // 4. Update storage ketika value berubah
//   useEffect(() => {
//     if (typeof window === "undefined") return;

//     try {
//       const stringValue = JSON.stringify(value);

//       if (hasStorage) {
//         window.sessionStorage.setItem(key, stringValue);
//       } else {
//         // Simpan ke memori fallback
//         memoryFallback.set(key, stringValue);
//       }
//     } catch (error) {
//       console.warn(`Error setting session storage key "${key}":`, error);
//     }
//   }, [key, value]);

//   return [value, setValue] as const;
// }

import { useState, useEffect } from "react";

// --- FUNGSI HELPER COOKIE ---
const setSessionCookie = (name: string, value: string) => {
  if (typeof document === "undefined") return;
  // Tanpa atribut 'expires' atau 'max-age', ini otomatis jadi Session Cookie
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax`;
};

const getSessionCookie = (name: string): string | null => {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) return decodeURIComponent(match[2]);
  return null;
};

// --- PENGECEKAN STORAGE ---
const isStorageAvailable = () => {
  if (typeof window === "undefined") return false;
  try {
    const testKey = "__storage_test__";
    window.sessionStorage.setItem(testKey, testKey);
    window.sessionStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false; // Safari Private Mode / Storage Disabled
  }
};

const hasStorage = isStorageAvailable();

export default function useSessionStorage<T>(key: string, initialValue: T) {
  // 1. Lazy Initialization
  const [value, setValue] = useState<T>(() => {
    if (typeof window === "undefined") return initialValue;

    try {
      let storedValue: string | null = null;

      if (hasStorage) {
        storedValue = window.sessionStorage.getItem(key);
      } else {
        // Fallback: Ambil dari Cookie
        storedValue = getSessionCookie(key);
      }

      return storedValue ? JSON.parse(storedValue) : initialValue;
    } catch (error) {
      console.warn(`Error reading session storage key "${key}":`, error);
      return initialValue;
    }
  });

  // 2. Update storage ketika value berubah
  useEffect(() => {
    if (typeof window === "undefined") return;

    try {
      const stringValue = JSON.stringify(value);

      if (hasStorage) {
        window.sessionStorage.setItem(key, stringValue);
      } else {
        // Fallback: Simpan ke Cookie
        setSessionCookie(key, stringValue);
      }
    } catch (error) {
      console.warn(`Error setting session storage key "${key}":`, error);
    }
  }, [key, value]);

  return [value, setValue] as const;
}
